import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@paypalcorp/pp-react';
import AppDispatcher from '../dispatcher/AppDispatcher';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { scrollElementIntoView } from '../utility/domUtils';
import { Container, Row, Col } from '@paypalcorp/pp-react-grid';

export class ServerErrors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessages: [],
    };
  }
  componentDidMount() {
    // Register for App Dispatcher Messages
    this.registerAppDispatcherMessages();
  }

  registerAppDispatcherMessages() {
    this.dispatcherMessages = AppDispatcher.register((payload) => {
      if (_get(payload, 'action.actionType') === 'UPDATE_SERVER_ERRORS') {
        const errorMessages = _get(payload, 'action.item.serverErrors', []);
        this.setState(
          {
            errorMessages,
          },
          () => {
            if (this.state.errorMessages.length > 0) {
              scrollElementIntoView('.service_error_holder');
            }
          }
        );
      }
    });
  }

  componentWillUnmount() {
    AppDispatcher.unregister(this.dispatcherMessages);
  }

  render() {
    const { errorMessages } = this.state;
    if (_isEmpty(errorMessages)) {
      return null;
    }

    return (
      <Container form={true} xxl={true} className="service_error_holder">
        {errorMessages.map((message, index) => {
          return (
            <Row key={message.key || index}>
              <Col sm={12} form={'vspace'}>
                <Alert type="error" className="error-text">
                  <div
                    className="guest-errors"
                    dangerouslySetInnerHTML={{ __html: message.value }}
                  />
                </Alert>
              </Col>
            </Row>
          );
        })}
      </Container>
    );
  }
}

ServerErrors.propTypes = {
  errorMessages: PropTypes.array,
};

export default ServerErrors;
